module.exports = __webpack_public_path__ + "static/interview-room-0b3e3a342a82d8813ee853d3a209cad0.png";